var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{style:(_vm.dotStyle)},[_vm._v("mdi-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }